<template>
    <div class="loading__container">
        <img src="./../../assets/loader-reload.svg" />
    </div>
</template>

<script>
export default {}
</script>

<style scoped>
.loading__container{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, .3);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
}

.loading__container img{
    width: 25%;
    height: 25%;
}
</style>